import type { ReactNode } from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import RouterOutlinedIcon from '@mui/icons-material/RouterOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import type { AuthUser } from '../api/types';

export interface NavItem {
  label: string;
  to: string;
  icon: ReactNode;
  roles: AuthUser['role'][];
}

const MANAGEMENT_ROLES: AuthUser['role'][] = ['ORG_ADMIN', 'MANAGER'];
const BILLING_ROLES: AuthUser['role'][] = [...MANAGEMENT_ROLES, 'BILLING'];
const CLIENT_ROLES: AuthUser['role'][] = [...BILLING_ROLES, 'VIEWER'];

export const NAV_ITEMS: NavItem[] = [
  { label: 'Platform', to: '/platform', icon: <BusinessOutlinedIcon />, roles: ['SUPER_ADMIN'] },
  { label: 'Dashboard', to: '/dashboard', icon: <DashboardOutlinedIcon />, roles: BILLING_ROLES },
  { label: 'Clients', to: '/clients', icon: <PeopleAltOutlinedIcon />, roles: CLIENT_ROLES },
  { label: 'Payments', to: '/payments', icon: <CreditCardOutlinedIcon />, roles: BILLING_ROLES },
  { label: 'Payment Methods', to: '/payment-methods', icon: <CreditCardOutlinedIcon />, roles: MANAGEMENT_ROLES },
  { label: 'Invoices', to: '/invoices', icon: <ReceiptLongOutlinedIcon />, roles: BILLING_ROLES },
  { label: 'Service Plans', to: '/service-plans', icon: <WifiOutlinedIcon />, roles: MANAGEMENT_ROLES },
  { label: 'MikroTik', to: '/mikrotik', icon: <RouterOutlinedIcon />, roles: MANAGEMENT_ROLES },
  { label: 'Users', to: '/users', icon: <ManageAccountsOutlinedIcon />, roles: ['ORG_ADMIN'] },
  { label: 'Settings', to: '/settings', icon: <SettingsOutlinedIcon />, roles: ['ORG_ADMIN'] },
  { label: 'Audit Logs', to: '/audit-logs', icon: <HistoryOutlinedIcon />, roles: ['SUPER_ADMIN', 'ORG_ADMIN'] },
];

